<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.areas')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-shield"></i>
          <span>{{$ml.get('shared.guardTourSystem')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.areas')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div
          class="col-xs-12 col-sm-6 col-md-4 col-lg-2"
          style="cursor:pointer;"
          data-toggle="modal"
          data-target="#modal-area"
          @click="selectArea(area)"
          v-for="area in areaList"
          :key="area.id"
        >
          <div class="box">
            <div class="box-header text-center">
              <h4 class="box-title">{{area.areaName}}</h4>
            </div>
            <div class="box-body text-center">
              <span>
                <img style="width:150px;"
                  :src="area.imagePath == '' || area.imagePath == null ? '/src/assets/buildings/office-building-19.png': '/src/assets/buildings/' + area.imagePath"
                />
              </span>
              <br />
            </div>
            <!--<div class="box-footer">
              <strong class="h4 text-muted">
                <i class="fa fa-users"></i> Personel Sayısı :
                <span style="color:black;">78</span>
              </strong>
            </div>-->
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2" style="cursor:pointer;" data-toggle="modal"
            data-target="#modal-area" @click="newArea()">
          <div class="box">
            <div class="box-body text-center text-primary">
              <span style="font-size:50px;padding-top:70px;display:inherit;">
                <i class="fa fa-plus-circle"></i>
                <h4>Yeni Bölge Ekle</h4>
              </span>
              <br />
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /.MODAL START-->
    <div class="modal fade" id="modal-area">
      <div :class="newImg ? 'modal-dialog modal-lg' : 'modal-dialog'">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span v-text="area.areaName != '' ? area.areaName : 'Yeni Bölge'"></span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div :class="newImg ? 'col-sm-8' : 'col-sm-12'">
                <div class="text-center">
                <img
                  @click="newImg = true"
                  :src="area.imagePath && area.imagePath != '' ? '/src/assets/buildings/' + area.imagePath : '/src/assets/buildings/office-building-19.png'"
                  style="cursor:pointer;width:200px;height:200px;"
                />
                <h3>
                  <span v-text="area.areaName != '' ? area.areaName : 'Yeni Bölge'"></span>
                </h3>
                <span class="text-muted">Görseli değiştirmek için üzerine tıklayın.</span>
                <h4></h4>
                </div>
                <div class="form-group" style="margin-top:10px;">
                  <label>
                    <i class="fa fa-pencil"></i> Bölge Adı
                  </label>
                  <input type="text" class="form-control" v-model="area.areaName" />
                </div>
              </div>
              <div v-show="newImg" class="col-sm-4">
                <label>
                  <i class="fa fa-picture-o"></i> Bölge Görseli
                </label>
                <div class="input-group" style="margin-bottom:7px;">
                  <input
                    v-model="searchText"
                    class="form-control"
                    type="text"
                    placeholder="Arama yapın..."
                    autocomplete="false"
                  />
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-primary ">
                      <i class="fa fa-search"></i>
                    </button>
                    <button
                      @click="searchText = ''"
                      v-show="searchText"
                      type="button"
                      class="btn btn-warning "
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </span>
                </div>
                <div
                  v-show="imgList.length > 0"
                  class="table-responsive no-padding"
                  style="height:400px;owerflow:auto;"
                >
                  <table class="table table-hover">
                    <tbody>
                      <tr
                        :class="area.imagePath == img.target ? 'bg-primary' : ''"
                        style="cursor:pointer;"
                        @click="area.imagePath = img.target;"
                        v-for="(img, index) in imgList"
                        :key="index"
                      >
                        <td>
                          <img
                            style="width:50px;height:50px;"
                            :src="'/src/assets/buildings/' + img.target"
                          />
                        </td>
                        <td style="padding-top:25px;">{{img.name}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-show="imgList.length == 0" class="callout callout-info">
                  <i class="fa fa-info-circle"></i>
                  Aramanıza uygun sonuç bulunamadı.
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="pull-left">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$ml.get('general.cancel')}}</button>
            </div>
            <div class="pull-right">
              <button
                data-dismiss="modal"
                v-show="!isNewArea"
                @click="deleteArea()"
                class="btn btn-danger "
              >
                <i class="fa fa-trash"></i>
                {{$ml.get('general.delete')}}
              </button>
              <button
                data-dismiss="modal"
                v-show="!isNewArea"
                @click="saveArea()"
                class="btn btn-success "
              >
                <i class="fa fa-refresh"></i>
                {{$ml.get('general.update')}}
              </button>
              <button
                data-dismiss="modal"
                v-show="isNewArea"
                @click="saveArea()"
                class="btn btn-success "
              >
                <i class="fa fa-check"></i>
                {{$ml.get('general.save')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.MODAL END -->
  </div>
</template>
<script>
import myUpload from "vue-image-crop-upload";
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {},
      searchText: "",
      isNewArea: true,
      newImg: false,
      area: {
        id: null,
        areaName: "",
        imagePath: ""
      },
      areas: []
    };
  },
  components: {
    "my-upload": myUpload
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  computed: {
    authControl() {
      return this.$store.getters.getAuthBekciTur;
    },
    modules() {
      return this.$store.getters.getModules;
    },
    buildings() {
      return this.$store.getters.getBuildings;
    },
    imgList() {
      if (this.searchText != "") {
        return this.buildings.filter(a => {
          return this.searchText
            .toLowerCase()
            .split(" ")
            .every(v => a.tags.toLowerCase().includes(v));
        });
      } else {
        return this.buildings;
      }
    },
    areaList() {
      return this.areas;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    newArea() {
      this.isNewArea = true;
      this.newImg = true;
      this.searchText = "";
      this.area.id = null;
      this.area.areaName = "";
      this.area.imagePath = "office-building-19.png";
    },
    selectArea(area) {
      this.isNewArea = false;
      this.newImg = false;
      this.searchText = "";
      this.area.id = area.id;
      this.area.areaName = area.areaName;
      this.area.imagePath = area.imagePath;
    },
    async getAreas() {
      try {
        this.isLoading = true;
        const areas = [];
        const response = await this.$axios
          .get("/GuardArea")
          .then(response => {
            response.data.forEach(doc => {
              areas.push({
                id: doc.id,
                areaName: doc.areaName,
                imagePath: doc.imagePath
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.areas = areas;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async deleteArea() {
      try {
        this.isLoadingDetail = true;
        let id = this.area.id;
        const response = await this.$axios
          .delete("/GuardArea/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getAreas();
        this.newArea();
        alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async saveArea() {
      if (this.area.areaName == "") {
        alertify.warning(this.$ml.get("alerts.pleaseEnterAUserName"));
        return;
      }
      this.isLoadingDetail = true;
      if (this.isNewArea) {
        try {
          let area2 = this.area;
          const response = await this.$axios
            .post("/GuardArea", {
              areaName: area2.areaName,
              imagePath: area2.imagePath
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getAreas();
          this.newArea();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let area2 = this.area;
          const response = await this.$axios
            .put("/GuardArea/" + area2.id, {
              areaName: area2.areaName,
              imagePath: area2.imagePath
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          try {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
          } catch (error) {}
          this.getAreas();
          this.newArea();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAreas();
  }
};
</script>
<style scoped>
.box {
  min-height: 300px;
  height: 300px;
  max-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/pages/guardTour/Areas.vue